import { module } from 'modujs';
import ClipboardJS from 'clipboard';

export default class extends module {
    constructor(m) {
        super(m);
        this.progressBar = document.querySelector('.o-navbar_progress');
    }

    init() {
        this.el.querySelectorAll('[data-clipboard-text]').forEach((elt) => {
            let clipboard = new ClipboardJS(elt);
            clipboard.on('success', function(e) {
                elt.closest('.shareWrap').classList.add('copied');
    
                setTimeout(() => {
                    elt.closest('.shareWrap').classList.remove('copied');
                }, 3000);
            
                e.clearSelection();
            });
        });

        if (this.progressBar) {
            window.addEventListener('articleProgress', (e) => {
                const { target, progress } = e.detail;
                this.progressBar.style.setProperty('--page-progress', progress);
            });
        }
    }
}
